var _defs, _defs2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLucree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_41_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -93.0472,
    x2: -93.0472,
    y1: -73.4134,
    y2: -17.2908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005129895,
    style: {
      stopColor: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2817,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    style: {
      stopColor: "#DDDDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8789,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    style: {
      stopColor: "#BDBDBD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_90_",
    d: "M-42.13-44.72c-0.91-4.33-4.3-20.11-5.87-27.41 c-0.47-2.21-2.11-3.82-3.99-3.81c-5.36,0-15.39-0.05-16.6-0.05c0,0-35.79,0-44.08,0c-0.61,0-2.56,0.06-4.11,1.79 c-4.7,5.27-12.54,20.52-13.76,22.07c-0.08,0.1-6.27,2.31-9.09,4c-1.12,0.67-1.74,2.13-1.9,3.63l-2.46,20.75 c-0.64,4.1,1.7,5.76,5.37,5.76h91.51c2.8,0,5.11-0.68,5.11-5.69v-19.79C-42-43.9-42.05-44.32-42.13-44.72z",
    style: {
      fill: "url(#XMLID_6_)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_68_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    d: "M-42.13-44.78c-0.91-4.32-4.3-20.06-5.87-27.34c-0.47-2.21-2.11-3.82-3.99-3.82 c-5.36,0-15.39-0.06-16.6-0.06c0,0-35.79,0-44.08,0c-0.61,0-2.56,0.07-4.11,1.8c-4.7,5.26-12.54,20.51-13.76,22.05 c-0.08,0.1-6.27,2.28-9.09,3.96c-1.12,0.67-1.74,2.13-1.9,3.62l-2.46,20.76c-0.64,4.09,1.7,5.81,5.37,5.81h91.51 c2.8,0,5.11-0.79,5.11-5.8v-19.74C-42-43.96-42.05-44.37-42.13-44.78z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#XMLID_69_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_61_",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-51.98-73c0.36,0,0.87,0.59,1.05,1.44c1.46,6.78,4.95,23.06,5.86,27.43 c0.04,0.2,0.07,0.44,0.07,0.66v19.79c0,2.81-0.49,2.69-2.11,2.69h-91.51c-1.3,0-2.02-0.23-2.25-0.5 c-0.23-0.27-0.3-0.92-0.16-1.77c0.01-0.04,0.01-0.06,0.02-0.09l2.47-20.83c0.08-0.8,0.36-1.28,0.46-1.36 c1.87-1.12,5.83-2.66,7.51-3.31c1.46-0.57,1.86-0.72,2.39-1.39c0.5-0.63,1.28-2,2.99-5.03c2.85-5.03,7.61-13.53,10.65-16.93 c0.57-0.64,1.22-0.79,1.87-0.79h44.08c0.75,0,4.89,0,9.21,0H-51.98H-52 M-51.98-76C-51.98-76-51.99-76-51.98-76 c-5.36,0-15.39,0-16.6,0c0,0-35.79,0-44.08,0c-0.01,0-0.01,0-0.02,0c-0.63,0-2.55,0.08-4.08,1.79 c-4.7,5.27-12.54,20.52-13.76,22.07c-0.08,0.1-6.27,2.31-9.09,4c-1.12,0.67-1.74,2.13-1.9,3.63l-2.46,20.75 c-0.64,4.1,1.7,5.76,5.37,5.76h91.51c2.8,0,5.11-0.68,5.11-5.69v-19.79c0-0.42-0.05-0.84-0.13-1.24 c-0.91-4.33-4.3-20.17-5.87-27.47C-48.47-74.4-50.11-76-51.98-76L-51.98-76z",
    style: {
      fill: "#424242"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.4303,
    x2: 46.4303,
    y1: -117.4969,
    y2: -61.3743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0106,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2496,
    style: {
      stopColor: "#5D5D5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5044,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7657,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#212121"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_142_",
    d: "M97.35-88.93c-0.91-4.33-4.3-20.11-5.86-27.41 c-0.47-2.21-2.11-3.75-3.99-3.75c-5.36,0-15.39,0.01-16.6,0.01c0,0-35.79,0-44.08,0c-0.61,0-2.56-0.01-4.11,1.73 C18-113.07,10.16-97.86,8.95-96.31c-0.08,0.1-6.27,2.3-9.09,3.99c-1.12,0.67-1.74,2.12-1.9,3.62l-2.46,20.8 c-0.64,4.1,1.7,5.82,5.37,5.82h91.51c2.8,0,5.1-0.8,5.1-5.81v-19.79C97.47-88.11,97.43-88.52,97.35-88.93z",
    style: {
      fill: "url(#XMLID_8_)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_136_"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    d: "M97.35-88.98c-0.91-4.32-4.3-20.06-5.86-27.34c-0.47-2.21-2.11-3.74-3.99-3.74 c-5.36,0-15.39,0.01-16.6,0.01c0,0-35.79,0-44.08,0c-0.61,0-2.56-0.01-4.11,1.72C18-113.06,10.16-97.85,8.95-96.31 c-0.08,0.1-6.27,2.26-9.09,3.94c-1.12,0.67-1.74,2.12-1.9,3.61L-4.51-68c-0.64,4.09,1.7,5.8,5.37,5.8h91.51 c2.8,0,5.1-0.79,5.1-5.8v-19.74C97.47-88.16,97.43-88.58,97.35-88.98z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#XMLID_141_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_129_",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5-117.08c0.36,0,0.87,0.53,1.05,1.38c1.46,6.78,4.94,23.03,5.86,27.4 c0.04,0.2,0.06,0.41,0.06,0.63v19.79c0,2.81-0.49,2.81-2.1,2.81H0.86c-1.3,0-2.02-0.29-2.25-0.56c-0.23-0.27-0.3-0.95-0.16-1.8 l0.01-0.05l0.01-0.05l2.47-20.84c0.08-0.8,0.36-1.28,0.46-1.36c1.87-1.12,5.83-2.66,7.51-3.31c1.46-0.57,1.86-0.72,2.39-1.39 c0.5-0.63,1.28-2,2.99-5.03c2.85-5.03,7.61-13.46,10.65-16.87c0.57-0.64,1.22-0.72,1.87-0.72h44.08c0.75,0,4.89,0,9.21-0.01 L87.5-117.08L87.5-117.08 M87.5-120.08C87.5-120.08,87.5-120.08,87.5-120.08c-5.36,0-15.39,0.01-16.6,0.01c0,0-35.79,0-44.08,0 c-0.01,0-0.01,0-0.02,0c-0.63,0-2.55,0.01-4.08,1.73C18-113.07,10.16-97.86,8.95-96.31c-0.08,0.1-6.27,2.3-9.09,3.99 c-1.12,0.67-1.74,2.12-1.9,3.62l-2.46,20.8c-0.64,4.1,1.7,5.82,5.37,5.82h91.51c2.8,0,5.1-0.8,5.1-5.81v-19.79 c0-0.42-0.04-0.84-0.13-1.24c-0.91-4.33-4.3-20.11-5.86-27.41C91.01-118.55,89.37-120.08,87.5-120.08L87.5-120.08z",
    style: {
      fill: "#EEEEEE"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.9375,
    x2: 63.9375,
    y1: 104.1532,
    y2: 27.8173
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE082"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.27,103.84H11.6c-4.2,0-7.63-3.43-7.63-7.63V35.57c0-4.2,3.43-7.63,7.63-7.63h104.67 c4.2,0,7.63,3.43,7.63,7.63v60.64C123.91,100.41,120.47,103.84,116.27,103.84z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 16.07,
    style: {
      fill: "#424242"
    },
    width: 119.95,
    x: 3.96,
    y: 43.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.13,80.03H13.81c-0.98,0-1.79-0.8-1.79-1.79v-8.41c0-0.98,0.8-1.79,1.79-1.79h100.32 c0.98,0,1.79,0.8,1.79,1.79v8.41C115.92,79.22,115.11,80.03,114.13,80.03z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.27,30.94c2.55,0,4.63,2.08,4.63,4.63v60.64c0,2.55-2.08,4.63-4.63,4.63H11.6 c-2.55,0-4.63-2.08-4.63-4.63V35.57c0-2.55,2.08-4.63,4.63-4.63H116.27 M116.27,27.94H11.6c-4.2,0-7.63,3.43-7.63,7.63v60.64 c0,4.2,3.43,7.63,7.63,7.63h104.67c4.2,0,7.63-3.43,7.63-7.63V35.57C123.91,31.37,120.47,27.94,116.27,27.94L116.27,27.94z",
    style: {
      fill: "#424242"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: " M26.25,72.01c-1.02,0.32-1.38,1.7-0.93,2.67c0.46,0.96,1.48,1.54,2.49,1.86c2.14,0.66,4.54,0.42,6.5-0.65 c2.15-1.18,3.74-3.28,6.02-4.2c3.31-1.33,7.02,0.17,10.21,1.77c3.19,1.6,6.69,3.36,10.15,2.51c3.55-0.87,6.47-4.4,10.09-3.82 c2.13,0.34,3.74,2.04,5.63,3.09c3.98,2.22,8.95,1.41,13.27-0.03c4.32-1.45,8.58-3.48,13.14-3.57",
    style: {
      fill: "none",
      stroke: "#424242",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 28,
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2625,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 83.5,
    x2: 83.5,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 43.5,
    x2: 43.5,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 63.5,
    x2: 63.5,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 64.5,
    y2: 64.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 44.5,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 83.5,
    y2: 83.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 128,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 0,
    x2: 128,
    y1: 128,
    y2: 0
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64,4.26c32.94,0,59.74,26.8,59.74,59.74S96.94,123.74,64,123.74S4.26,96.94,4.26,64S31.06,4.26,64,4.26 M64,4 C30.86,4,4,30.86,4,64s26.86,60,60,60s60-26.86,60-60S97.14,4,64,4L64,4z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M115.5,108.47c0,4.43-3.59,8.03-8.03,8.03H19.53 c-4.43,0-8.03-3.59-8.03-8.03V20.53c0-4.43,3.59-8.03,8.03-8.03h87.94c4.43,0,8.03,3.59,8.03,8.03V108.47z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,116.5c0,4.42-3.58,8-8,8h-72 c-4.42,0-8-3.58-8-8v-104c0-4.42,3.58-8,8-8h72c4.42,0,8,3.58,8,8V116.5z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.5,98.27c0,5.65-4.58,10.23-10.23,10.23H13.73 c-5.65,0-10.23-4.58-10.23-10.23V30.73c0-5.65,4.58-10.23,10.23-10.23h99.54c5.65,0,10.23,4.58,10.23,10.23V98.27z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_2_",
    height: 128,
    style: {
      opacity: 0.2
    },
    width: 128,
    x: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_2_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_3_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -28.5,
    x2: -28.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -24.5,
    x2: -24.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -20.5,
    x2: -20.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -16.5,
    x2: -16.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -12.5,
    x2: -12.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -8.5,
    x2: -8.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -4.5,
    x2: -4.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -0.5,
    x2: -0.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 3.5,
    x2: 3.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 7.5,
    x2: 7.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 11.5,
    x2: 11.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 15.5,
    x2: 15.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 19.5,
    x2: 19.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 23.5,
    x2: 23.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 27.5,
    x2: 27.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 31.5,
    x2: 31.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 35.5,
    x2: 35.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 39.5,
    x2: 39.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 43.5,
    x2: 43.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 47.5,
    x2: 47.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 51.5,
    x2: 51.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 55.5,
    x2: 55.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 59.5,
    x2: 59.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 63.5,
    x2: 63.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 67.5,
    x2: 67.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 71.5,
    x2: 71.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 75.5,
    x2: 75.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 79.5,
    x2: 79.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 83.5,
    x2: 83.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 87.5,
    x2: 87.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 91.5,
    x2: 91.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 95.5,
    x2: 95.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 99.5,
    x2: 99.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 103.5,
    x2: 103.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 107.5,
    x2: 107.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 111.5,
    x2: 111.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 115.5,
    x2: 115.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 119.5,
    x2: 119.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 123.5,
    x2: 123.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 127.5,
    x2: 127.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 131.5,
    x2: 131.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 135.5,
    x2: 135.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 136.5,
    x2: 136.5,
    y1: 166,
    y2: -26
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 143.5,
    x2: 143.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 147.5,
    x2: 147.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 151.5,
    x2: 151.5,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 155.5,
    x2: 155.5,
    y1: 160,
    y2: -32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -27.5,
    y2: -27.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -23.5,
    y2: -23.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -19.5,
    y2: -19.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -15.5,
    y2: -15.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -11.5,
    y2: -11.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -7.5,
    y2: -7.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -3.5,
    y2: -3.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 0.5,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 4.5,
    y2: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 8.5,
    y2: 8.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 12.5,
    y2: 12.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 16.5,
    y2: 16.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 20.5,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 24.5,
    y2: 24.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 28.5,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 32.5,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 36.5,
    y2: 36.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 40.5,
    y2: 40.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 44.5,
    y2: 44.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 48.5,
    y2: 48.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 52.5,
    y2: 52.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 56.5,
    y2: 56.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 60.5,
    y2: 60.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 64.5,
    y2: 64.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 68.5,
    y2: 68.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 72.5,
    y2: 72.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 76.5,
    y2: 76.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 80.5,
    y2: 80.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 84.5,
    y2: 84.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 88.5,
    y2: 88.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 92.5,
    y2: 92.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 96.5,
    y2: 96.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 100.5,
    y2: 100.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 104.5,
    y2: 104.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 108.5,
    y2: 108.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 112.5,
    y2: 112.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 116.5,
    y2: 116.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 120.5,
    y2: 120.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 124.5,
    y2: 124.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 128.5,
    y2: 128.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 132.5,
    y2: 132.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 136.5,
    y2: 136.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 140.5,
    y2: 140.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 144.5,
    y2: 144.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 148.5,
    y2: 148.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 152.5,
    y2: 152.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 156.5,
    y2: 156.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160-32v192H-32V-32H160 M160-32H-32v192h192V-32L160-32z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 0
  }), /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 124
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 66 -62)",
    width: 4,
    x: 62,
    y: -58
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 190 62)",
    width: 4,
    x: 62,
    y: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucree);
export default __webpack_public_path__ + "static/media/lucree.e17015a5a3d6b89f940c021a8eb48ca9.svg";
export { ForwardRef as ReactComponent };